module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "stale"
  }, [_c('div', {
    staticClass: "staleContent"
  }, [(_vm.couponsFn && _vm.couponsFn.length) ? _c('div', _vm._l((_vm.couponsFn), function(item, index) {
    return _c('xk-couponMod', {
      key: index,
      attrs: {
        "type": item.type,
        "sum": item.sum,
        "title": item.title,
        "startTime": item.startTime,
        "endTime": item.endTime,
        "overdueTime": item.overdueTime,
        "couponType": item.couponType,
        "status": 1,
        "useState": 3,
        "serviceType": item.serviceType
      }
    })
  }), 1) : _c('div', {
    staticClass: "shixiao"
  }, [_c('h2', [_vm._v("\n        暂无失效优惠券记录\n      ")])])]), _vm._v(" "), (_vm.hintBox.stateShow) ? _c('xk-hint-box', {
    attrs: {
      "state": _vm.hintBox.state,
      "content": _vm.hintBox.content
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4d518436","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/mewallet/coupon/stale.vue
// module id = 532
// module chunks = 0